import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function OrdersIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="62"
        y="18"
        width="36"
        height="62"
        rx="5"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="70" y="26" width="20" height="4" rx="2" fill={c.p200} />
      <rect x="74" y="34" width="12" height="4" rx="2" fill={c.p200} />
      <circle cx="80" cy="50" r="6" fill={c.s500} />
      <path d="M77 50l2 2 4-5" stroke={c.n0} strokeWidth="2" />
      <path d="M48 78L80 94V130L48 114Z" fill={c.p500} />
      <path d="M112 78L80 94V130L112 114Z" fill={c.p600} />
      <path d="M80 62L112 78L80 94L48 78Z" fill={c.p300} />
      <path d="M67 68L99 84L93 88L61 72Z" fill={c.a300} />
    </Frame>
  );
}
